import { Search } from 'lucide-react';
import React from 'react';

export function SearchField({ value, onChange, onKeyDown, placeholder }) {
  return (
    <div className="search-field">
      <Search className="search-field__icon" size={18} aria-hidden="true" />
      <input
        className="search-field__input"
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        aria-label={placeholder || 'Search movies'}
      />
    </div>
  );
}
